import { createRoot } from 'react-dom/client';
import { SearchBar } from './components/SearchBar.js';


export function initializeSearchBars() {
  document.querySelectorAll('.superlok-search-bar-root').forEach(el => {
    const ptype = (el as HTMLElement).dataset.ptype;
    createRoot(el).render(<SearchBar ptype={ptype || ""} />);
  });
}

